// This file is auto-generated from elements/myrh-solutions-from-partners/data/categories.csv
// Do not edit this file directly

export const CATEGORIES = {
  "AI": {
    "iconName": "new",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=AI",
    "es": "IA",
    "de": "KI",
    "fr": "IA",
    "it": "AI",
    "ko": "AI",
    "zh": "AI",
    "pt-br": "Inteligência artificial",
    "ja": "AI"
  },
  "App Dev": {
    "iconName": "application",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=App%20dev",
    "es": "Desarrollo de aplicaciones",
    "de": "App-Entwicklung",
    "fr": "Développement d'applications",
    "it": "Sviluppo app",
    "ko": "애플리케이션 개발",
    "zh": "应用开发",
    "pt-br": "Desenvolvimento de apps",
    "ja": "アプリケーション開発"
  },
  "App modernization": {
    "iconName": "enhancement",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=App%20modernization",
    "es": "Modernización de aplicaciones",
    "de": "App-Modernisierung",
    "fr": "Modernisation des applications",
    "it": "Modernizzazione app",
    "ko": "애플리케이션 현대화",
    "zh": "应用现代化",
    "pt-br": "Modernização de apps",
    "ja": "アプリケーションのモダナイゼーション"
  },
  "Automation": {
    "iconName": "settings",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=Automation",
    "es": "Automatización",
    "de": "Automatisierung",
    "fr": "Automatisation",
    "it": "Automazione",
    "ko": "자동화",
    "zh": "自动化",
    "pt-br": "Automação",
    "ja": "自動化"
  },
  "Cloud": {
    "iconName": "cloud",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=Cloud",
    "es": "Nube",
    "de": "Cloud",
    "fr": "Cloud",
    "it": "Cloud",
    "ko": "클라우드",
    "zh": "云",
    "pt-br": "Nuvem",
    "ja": "クラウド"
  },
  "Data management": {
    "iconName": "data",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=Data%20management",
    "es": "Gestión de datos",
    "de": "Datenmanagement",
    "fr": "Gestion des données",
    "it": "Gestione dati",
    "ko": "데이터 관리",
    "zh": "数据管理",
    "pt-br": "Gerenciamento de dados",
    "ja": "データ管理"
  },
  "DevOps": {
    "iconName": "loop",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=DevOps",
    "es": "DevOps",
    "de": "DevOps",
    "fr": "DevOps",
    "it": "DevOps",
    "ko": "DevOps",
    "zh": "DevOps",
    "pt-br": "DevOps",
    "ja": "DevOps"
  },
  "Edge": {
    "iconName": "cloud-edge",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=Edge",
    "es": "Edge",
    "de": "Edge",
    "fr": "Edge computing",
    "it": "Edge",
    "ko": "엣지",
    "zh": "边缘",
    "pt-br": "Edge computing",
    "ja": "エッジ"
  },
  "Infrastructure": {
    "iconName": "puzzle-piece",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=Infrastructure",
    "es": "Infraestructura",
    "de": "Infrastruktur",
    "fr": "Infrastructure",
    "it": "Infrastruttura",
    "ko": "인프라",
    "zh": "基础架构",
    "pt-br": "Infraestrutura",
    "ja": "インフラストラクチャ"
  },
  "IT & management tools": {
    "iconName": "controls",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=IT%20%26%20management%20tools",
    "es": "Herramientas de gestión y TI",
    "de": "IT- und Managementtools",
    "fr": "Outils informatiques et de gestion",
    "it": "Strumenti IT e gestione",
    "ko": "IT & 관리 툴",
    "zh": "IT 和管理工具",
    "pt-br": "Ferramentas de TI e gerenciamento",
    "ja": "IT & 管理ツール"
  },
  "Migration": {
    "iconName": "migrate",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=Migration",
    "es": "Migración",
    "de": "Migration",
    "fr": "Migration",
    "it": "Migrazione",
    "ko": "마이그레이션",
    "zh": "迁移",
    "pt-br": "Migração",
    "ja": "移行"
  },
  "Networking": {
    "iconName": "language",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=Networking",
    "es": "Redes",
    "de": "Netzwerk",
    "fr": "Mise en réseau",
    "it": "Reti",
    "ko": "네트워킹",
    "zh": "网络",
    "pt-br": "Redes",
    "ja": "ネットワーク"
  },
  "Security": {
    "iconName": "secured",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=Security",
    "es": "Seguridad",
    "de": "Sicherheit",
    "fr": "Sécurité",
    "it": "Sicurezza",
    "ko": "보안",
    "zh": "安全防护",
    "pt-br": "Segurança",
    "ja": "セキュリティ"
  },
  "Virtualization": {
    "iconName": "virtual-server",
    "iconSet": "ui",
    "url": "https://catalog.redhat.com/search?p=1&subcategories=Virtualization",
    "es": "Virtualización",
    "de": "Virtualisierung",
    "fr": "Virtualisation",
    "it": "Virtualizzazione",
    "ko": "가상화",
    "zh": "虚拟化",
    "pt-br": "Virtualização",
    "ja": "仮想化"
  }
} as const;
